
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"15.5","stroke":"currentColor","stroke-opacity":".3"}}),_c('path',{attrs:{"d":"M11.448 22c-.4 0-.736-.139-1.024-.408-.28-.269-.424-.6-.424-.984v-7.216c0-.384.144-.707.424-.984S11.048 12 11.448 12h.952v-1.539c0-.961.352-1.776 1.048-2.453C14.152 7.33 15 7 16 7s1.848.338 2.552 1.008c.704.677 1.048 1.492 1.048 2.454V12h.952c.4 0 .736.139 1.024.408.288.269.424.6.424.984v7.216c0 .384-.144.707-.424.984a1.43 1.43 0 01-1.024.408h-9.104zm5.544-4.046A1.27 1.27 0 0017.4 17a1.27 1.27 0 00-.408-.954 1.374 1.374 0 00-.992-.392c-.392 0-.72.13-.992.392A1.27 1.27 0 0014.6 17c0 .377.136.692.408.954.272.261.6.392.992.392s.72-.13.992-.392zM13.6 12h4.8v-1.539c0-.638-.232-1.184-.704-1.638-.472-.454-1.032-.677-1.704-.677-.672 0-1.232.223-1.704.677a2.176 2.176 0 00-.704 1.638V12h.016z","fill":"currentColor"}})])
          )
        }
      }
    